import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { StockReturnRequestProvider } from '../centerWarehouse/stockReturnRequestReceiveApproval/ContextAPI';
import Index from '../centerWarehouse/stockReturnRequestReceiveApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function StockReturnRequestCentralReceiveApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['stock-return-request-central-receive-approval'])
        return <PermissionDenied />;

    return (
        <StockReturnRequestProvider>
            <Index />
        </StockReturnRequestProvider>
    );
}
